<script lang="ts">
import FlexibilityIcon from "@/components/icons/flexibility-icon.vue"
import { Route } from "vue-router"

export default {
    name: "GroupFloatingBarOptions",
    components: {
        FlexibilityIcon,
    },
    props: {
        notificationCount: {
            type: Number,
            required: true,
        },
    },
    computed: {
        route(): Route {
            // @ts-ignore
            return this.$route
        },
        companyId() {
            return this.route.params.companyId
        },
        locationGroupId() {
            return this.route.params.locationGroupId
        },
        locationId() {
            return this.route.params.locationId
        },
        locationUrlPrefix() {
            const segments = []

            if (this.companyId) {
                segments.push(`companies/${this.companyId}`)
            }

            if (this.locationGroupId) {
                segments.push(`location-groups/${this.locationGroupId}`)
            }

            if (this.locationId) {
                segments.push(`locations/${this.locationId}`)
            }

            return `/${segments.join("/")}`
        },
    },
    methods: {
        isRouteActive(route: any) {
            return route.fullPath === this.route.path
        },
        openNotificationsModal() {
            this.$emit("open-notifications-modal")
        },
    },
}
</script>

<template>
    <ul class="nav location-nav display_flex_evenly">
        <!-- <li class="nav-item">
            <router-link :to="{ path: locationUrlPrefix }" v-slot="{ href, route, navigate }" custom>
                <a title="Summary" class="nav-link" :class="[isRouteActive(route) && 'router-link-exact-active']"
                    :href="href" @click="navigate">
                    <span class="icon icon-home"></span>
                </a>
            </router-link>
        </li> -->
        <li class="nav-item">
            <router-link
                :to="{ path: locationUrlPrefix + '/flexibility' }"
                v-slot="{ href, route, navigate }"
                custom
            >
                <a
                    :title="$t('floating_bar_options.flexibility')"
                    class="nav-link"
                    :class="[isRouteActive(route) && 'router-link-exact-active']"
                    :href="href"
                    @click="navigate"
                >
                    <!-- <span class="icon icon-system"></span> -->
                    <FlexibilityIcon class="icon" style="height: 25px" />
                </a>
            </router-link>
        </li>
        <!-- <li class="nav-item">
            <router-link :to="{ path: locationUrlPrefix + '/charts' }" v-slot="{ href, route, navigate }" custom>
                <a title="Summary charts" class="nav-link" :class="[isRouteActive(route) && 'router-link-exact-active']"
                    :href="href" @click="navigate">
                    <span class="icon icon-chart"></span>
                </a>
            </router-link>
        </li> -->
        <li class="nav-item">
            <div
                :title="$t('floating_bar_options.notifications')"
                class="nav-link cursor-pointer alert-indicator"
                @click="openNotificationsModal"
            >
                <span class="icon icon-bell"></span>
                <span class="alarms-count" v-if="notificationCount > 0">{{
                    notificationCount
                }}</span>
            </div>
        </li>
    </ul>
</template>

<style lang="scss">
@media (max-width: 768px) {
    .display_flex_evenly {
        gap: 1rem;
    }
}
</style>
